import { msalEnvironment } from '@qaroni-env/environment';

export const MsalEnv = {
  clientId: Object.prototype.hasOwnProperty.call(msalEnvironment, 'clientId')
    ? msalEnvironment.clientId
    : null,
  authority: Object.prototype.hasOwnProperty.call(msalEnvironment, 'authority')
    ? msalEnvironment.authority
    : null,
  redirectUri: Object.prototype.hasOwnProperty.call(
    msalEnvironment,
    'redirectUri'
  )
    ? msalEnvironment.redirectUri
    : null,
  scopes: Object.prototype.hasOwnProperty.call(msalEnvironment, 'scopes')
    ? msalEnvironment.scopes
    : [],
};
